// Accessibility enhancement plugin for keyboard navigation
export default ({ app }, inject) => {
  if (process.client) {
    // Add keyboard support to accordion items after mount
    app.router.afterEach(() => {
      setTimeout(() => {
        // Add tabindex and keyboard handlers to SfAccordion headers
        const accordionHeaders = document.querySelectorAll('.sf-accordion-item__header');
        accordionHeaders.forEach((header) => {
          if (!header.hasAttribute('tabindex')) {
            header.setAttribute('tabindex', '0');
            header.setAttribute('role', 'button');
          }
          
          // Add keyboard event listeners if not already present
          if (!header.hasAttribute('data-keyboard-enabled')) {
            header.setAttribute('data-keyboard-enabled', 'true');
            
            header.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                header.click();
              }
            });
          }
        });
      }, 100);
    });
  }
};
